// extracted by mini-css-extract-plugin
module.exports = {"button":"TrimText__button___3BeQj"};